import { forwardRef, useState } from "react";
import classNames from "classnames";

import { ReactComponent as HideEye } from '../../assets/icons_svg/hide_eye.svg';

import EditableField from "../../common/EditableField/EditableField";
import useMutateStatus from "../../hooks/useMutateStatus";

import './StatusColumn.scss';

const StatusColumn = forwardRef(({ children, columns = 1, handleProps, horizontal, hover, hoverSelf, onClick, onRemove, status, placeholder, style, scrollable, shadow, unstyled, onAddLead, onToggleColumn, ...props }, ref) => {
  const Component = onClick ? "button" : "div";
  const [edit, setEdit] = useState(false);

  const showIds = localStorage.getItem('pl__dev_show_kanban_ids') === 'true';

  const onToggleEdit = value => {
    setEdit(value);
  }

  const onEditSucces = () => {
    // showSavedToast('Lead status updated')
  }
  
  return (
    <Component {...props} ref={ref} style={{ ...style, "--columns": columns }} className={classNames('__kanban-column', { unstyled, horizontal, hover, hoverSelf, placeholder, scrollable, shadow })} onClick={onClick} tabIndex={onClick ? 0 : undefined}>
      <div className='header'>
        <div className="status-color" style={{ backgroundColor: `#${status?.color}` }} />
        <EditableField maxLength={64} field='name' initialValue={status.name} id={status.id} onEditSucces={onEditSucces} mutation={useMutateStatus} updateName='updateStatus' onToggleEdit={onToggleEdit} />
        {/* <div className="status-title">{ status?.name }</div> */}
        { showIds && <code>{ status?.id }</code> }
        { !edit && <button className="status-hide" onClick={onToggleColumn}><HideEye /></button> }
        { !edit && <button className="status-add" onClick={onAddLead}><div>+</div></button> }
      </div>
      <div className='items'>{ placeholder ? children : <ul>{ children }</ul> }</div>
    </Component>
  );
});

export default StatusColumn;
